import React, { createContext, useContext, useEffect } from 'react';

type GuiTheme = 'futuristic';

interface ThemeContextType {
  theme: GuiTheme;
  loading: boolean;
  refreshTheme: () => Promise<void>;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

const refreshTheme = async () => undefined;

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const theme: GuiTheme = 'futuristic';

  useEffect(() => {
    document.body.classList.add('theme-futuristic');

    return () => {
      document.body.classList.remove('theme-futuristic');
    };
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, loading: false, refreshTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
